import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Card, CardHeader } from 'react-bootstrap';
import { FaUtensils, FaHome, FaUsers } from 'react-icons/fa';

const MenuHogarSSV = ({ idEncuesta }) => {
    return (
        <Card>
            <CardHeader style={{backgroundColor:"#f7f7f7", fontSize: "18px", textAlign: "center", padding: "7px 10px", marginTop: "0"}}>
                HOGAR
            </CardHeader>
            <Card.Body>
                <div className="row mt-4">
                    <div className="col-md-4">
                        <Card style={{ backgroundColor: '#e8f1ff', border: '1px solid #cfe0ff' }}>
                            <Card.Body>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                                    <FaUtensils style={{ fontSize: '4.5rem', color: '#1d4ed8' }} />
                                    <h1 style={{ margin: 10 }}>Alimentación</h1>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <NavLink to={`/encuestassv/alimentacion/${idEncuesta}`} className="btn btn-primary">
                                        Ir al Formulario
                                    </NavLink>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <Card style={{ backgroundColor: '#e9f9f0', border: '1px solid #c7efd9' }}>
                            <Card.Body>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                                    <FaHome style={{ fontSize: '4.5rem', color: '#15803d' }} />
                                    <h1 style={{ margin: 10 }}>Vivienda</h1>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <NavLink to={`/encuestassv/vivienda/${idEncuesta}`} className="btn btn-success">
                                        Ir al Formulario
                                    </NavLink>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <Card style={{ backgroundColor: '#fff6dd', border: '1px solid #ffe3a3' }}>
                            <Card.Body>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                                    <FaUsers style={{ fontSize: '4.5rem', color: '#b45309' }} />
                                    <h1 style={{ margin: 10 }}>Reunificación</h1>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <NavLink to={`/encuestassv/reunificacion/${idEncuesta}`} className="btn btn-warning">
                                        Ir al Formulario
                                    </NavLink>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

MenuHogarSSV.propTypes = {
    idEncuesta: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default MenuHogarSSV;